import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatDialog } from '@angular/material/dialog';
import { GuideViewerComponent } from '../../dialogs/guide-viewer/guide-viewer.component';
import { CasualDialogTypesEnum } from '../../services/casual-report.service';
import { CommonService, VrmFileIcon } from '../../services/common.service';
import { DocumentGeneratorData, ReportsService } from '../../services/reports.service';

@Component({
  selector: 'column-to-icon-link',
  template: `
    <span [matTooltip]="value" *ngIf="!showButton">
      <button
        mat-button
        fxFlex
        class="sharp-corners bold grid-text"
        style="text-decoration: underline"
        vrm-color
        (click)="triggerLinkButtonAction()"
        *ngIf="value; else displayValueOnly"
      >
        <i [class]="fileIcon.icon" [style.color]="fileIcon.color" style="font-size: 25px; position: relative; top: 2px">
        </i>
      </button>

      <ng-template #displayValueOnly>{{ value }}</ng-template>
    </span>
    <span *ngIf="showButton">
      <button
        mat-button
        vrm-button
        fxFlex
        class="grid-text-centred force grid-text"
        style="color: white; padding-right: 0;"
        (click)="triggerLinkButtonAction()"
        *ngIf="value"
      >
        <span>
          {{ 'GENERIC.view' | translate }}
        </span>
      </button>
    </span>
  `,
  styles: [],
})
export class FileExtToIconAndLinkButtonComponent implements ICellRendererAngularComp {
  public fileIcon: VrmFileIcon;
  public value: string;
  public showButton: boolean;
  private documentGenerator: DocumentGeneratorData;
  private guideViewerDialog = GuideViewerComponent;
  private data: { [key: string]: any };

  public constructor(private dialog: MatDialog, private cService: CommonService, private rptService: ReportsService) {}

  public agInit(params) {
    this.value = params.value;
    this.data = params.data;
    this.fileIcon = this.cService.getApplicableIconForExtension(this.value);
    this.documentGenerator = this.rptService.getDocumentGenerator();
    this.showButton = this.documentGenerator ? this.documentGenerator.showButton : false;
  }

  triggerLinkButtonAction() {
    console.log('%c PDF LINK BUTTON ACTION', 'color: lightblue', {
      defaultSelection: this.data,
      value: this.value,
    });

    if (this.data) {
      this.dialog.open(this.guideViewerDialog, {
        height: '100%',
        maxHeight: this.cService.isMobileViewport ? '100%' : '',
        maxWidth: this.cService.isMobileViewport ? '100%' : '',
        width: this.cService.isMobileViewport ? '100%' : '95%',

        data: {
          selectedRow: this.data,
          casualDialogType: CasualDialogTypesEnum.guideViewer,
          fileToFetch: 'report-file',
          documentGeneratorData: this.documentGenerator,
        },

        disableClose: true,
      });
    }
  }

  public refresh(): boolean {
    return false;
  }
}
